// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── Dark mode overrides ─────────────────────────────────────
   Use body.theme-dark (not :host-context) so rules apply to
   Material Dialog content rendered in the CDK overlay.
   ──────────────────────────────────────────────────────────── */
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .container {
  background: #111827 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .box {
  background: #111827 !important;
  background-color: #111827 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .des-box {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e2e8f0 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .des-box::after,
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .des-box::before {
  background: #111827 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .dialog-header {
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .search-input {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .section-header h3 {
  color: #e2e8f0 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .pagination-info {
  background: #1f2937 !important;
  color: #94a3b8 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .selected-users {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .selected-users h4 {
  color: #e2e8f0 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .user-option:hover {
  background-color: #253347 !important;
  background: #253347 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .user-option:hover .user-name {
  color: #e2e8f0 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .user-option:hover .user-email {
  color: #94a3b8 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .user-option:hover mat-icon {
  color: #e2e8f0 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .user-name {
  color: #e2e8f0 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .user-email,
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .searching-users,
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .users-section .no-users {
  color: #94a3b8 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .page-btn {
  background: #1f2937 !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .page-btn:hover:not(:disabled) {
  background: #2d3748 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .page-btn.active {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border-color: #5ea1d8 !important;
}
body.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access .action-buttons {
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}

/* Match Transfer Ownership styles for users list */
.search-section {
  margin-bottom: 24px;
}
.search-section .search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.search-section .search-input-wrapper .search-icon {
  position: absolute;
  left: 12px;
  color: #666;
  z-index: 1;
}
.search-section .search-input-wrapper .search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.search-section .search-input-wrapper .search-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.search-section .search-input-wrapper .search-input::placeholder {
  color: #999;
}

.users-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.users-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.users-section .section-header .pagination-info {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 12px;
}
.users-section .selected-users {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.users-section .selected-users h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.users-section .selected-users mat-chip-listbox {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.users-section .selected-users mat-chip-option {
  background: #d8e4f7;
  color: white;
  font-size: 12px;
}
.users-section .selected-users mat-chip-option:hover {
  background: #999;
}
.users-section .selected-users mat-chip-option .mat-mdc-chip-remove {
  color: white;
  opacity: 0.8;
}
.users-section .selected-users mat-chip-option .mat-mdc-chip-remove:hover {
  opacity: 1;
}
.users-section .searching-users {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
}
.users-section .no-users {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #999;
}
.users-section .users-list {
  margin-bottom: 16px;
}
.users-section .users-list .user-option {
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
}
.users-section .users-list .user-option:hover {
  background-color: #eef2f7;
}
.users-section .users-list .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  min-width: 0;
}
.users-section .users-list .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.users-section .users-list .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.users-section .users-list .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}
.users-section .users-list .user-info {
  flex: 1;
  min-width: 0;
}
.users-section .users-list .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  font-size: 14px;
}
.users-section .users-list .user-email {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.users-section .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}
.users-section .nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.users-section .nav-btn:hover {
  background: #f5f5f5;
}
.users-section .nav-btn:disabled:hover {
  background: transparent;
}
.users-section .page-numbers {
  display: flex;
  gap: 4px;
}
.users-section .page-btn {
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #666;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.users-section .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.users-section .page-btn.active {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}

/* Create Flow Mode Notice */
.create-flow-notice {
  background: #e3f2fd;
  border: 1px solid #5ea1d8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #1976d2;
}
.create-flow-notice .notice-icon {
  color: #5ea1d8;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* Title Section */
.title-section {
  text-align: center;
  margin-bottom: 20px;
}
.title-section h2 {
  color: #333;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 600;
}
.title-section p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* Search Section */
.search-section {
  margin-bottom: 20px;
}
.search-section .search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}
.search-section .search-input:focus {
  border-color: #5ea1d8;
}
.search-section .search-input::placeholder {
  color: #999;
}

/* Users Section */
.users-section {
  margin-bottom: 20px;
}
.users-section .user-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}
.users-section .user-item:hover {
  background-color: #f8f9fa;
}
.users-section .user-item .transfer-checkbox {
  margin-right: 16px;
}
.users-section .user-item .user-avatar {
  margin-right: 16px;
  cursor: pointer;
}
.users-section .user-item .user-avatar .avatar-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.users-section .user-item .user-avatar .avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.users-section .user-item .user-avatar .avatar-placeholder .material-icons {
  font-size: 24px;
  color: #666;
}
.users-section .user-item .user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.users-section .user-item .user-info .user-name {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}
.users-section .user-item .user-info .user-username {
  color: #666;
  font-size: 14px;
}
.users-section .user-item .user-info .user-email {
  color: #999;
  font-size: 12px;
}

/* Loading Section */
.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  color: #666;
}
.loading-section mat-spinner {
  margin-right: 8px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
.action-buttons .cancel-btn {
  color: #666;
}
.action-buttons .confirm-btn {
  background-color: #5ea1d8;
  color: white;
}
.action-buttons .confirm-btn:disabled {
  background-color: #ccc;
  color: #666;
}

/* BASIC */
.Login {
  background-color: white;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}

.example-full-width {
  width: 100%;
}

.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 560px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff !important;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
  opacity: 1 !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 100vh;
  background: #fff;
  border-radius: 0px;
  position: absolute;
  top: 0px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.des-box:before {
  content: "";
  width: 200%;
  height: 40vh;
  background: #fff;
  border-radius: 100% 100% 0px 0px;
  position: absolute;
  top: -34px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}

.priceIcon-p {
  top: unset !important;
  bottom: 20px !important;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 15px;
  right: 25px;
  color: white;
  opacity: 1 !important;
  z-index: 10;
}

.close-ico .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-container input:focus {
  border: 1px solid #5ea1d8;
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
  }
}
.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 500px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: #fff;
  border-radius: 0px;
  margin: 0px auto;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 8px 0;
  background: transparent;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}
.dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
}
.dialog-header .header-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #333;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.popuptitle {
  text-align: left;
  font-size: 20px !important;
  padding-left: 15px;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
  box-shadow: none !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 100vh;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: -100px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 80px 0px;
  display: none;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
}

.close-ico .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-container input:focus {
  border: 1px solid #5ea1d8;
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  p span {
    width: 100%;
    display: flex;
  }
  .box {
    max-width: 47vh;
    width: 95vw !important;
    margin: 2.5vh auto !important;
    padding: 0px 15px !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
  }
  .close-ico {
    top: 8px;
    right: 8px;
  }
}
.ownership-warning {
  margin: 20px;
  text-align: left;
}
.ownership-warning .note-box {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 5px;
  padding: 15px;
  font-size: 14px;
}
.ownership-warning .note-list {
  margin: 10px 0;
  padding-left: 0;
  list-style: none;
}
.ownership-warning .note-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 8px;
}
.ownership-warning .note-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 8px;
  height: 8px;
  background-color: #856404;
  border-radius: 50%;
}
.ownership-warning .ownership-buttons {
  margin-top: 15px;
}
.ownership-warning .ownership-buttons button + button {
  margin-left: 10px;
}

/* Comment Form Styling */
.comment-form-section {
  margin: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.comment-form-section .example-form {
  margin: 0;
}
.comment-form-section .example-form .w-100 {
  width: 100%;
}
.comment-form-section .example-form .font16 {
  font-size: 16px;
  font-weight: 500;
  color: #495057;
}
.comment-form-section .example-form mat-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-text-field-wrapper {
  background-color: #fff;
  border-radius: 6px;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-focus-overlay {
  background-color: transparent;
}
.comment-form-section .example-form mat-form-field input {
  font-size: 14px;
  color: #495057;
}
.comment-form-section .example-form mat-form-field input::placeholder {
  color: #6c757d;
  opacity: 0.7;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-hint {
  color: #6c757d;
  font-size: 12px;
}

.transfer-ownership-dialog {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
:host-context(body.theme-dark) .transfer-ownership-dialog {
  background: #1a1a1a;
  color: #ffffff;
}
@media (prefers-contrast: high) {
  .transfer-ownership-dialog {
    border: 2px solid #000000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .transfer-ownership-dialog * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
.transfer-ownership-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: transparent;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}
.transfer-ownership-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #333;
}
.transfer-ownership-dialog .dialog-header .header-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #333;
}
.transfer-ownership-dialog .dialog-header .close-button {
  color: #666;
  transition: color 0.2s ease;
}
.transfer-ownership-dialog .dialog-header .close-button:hover {
  color: #333;
  background: rgba(0, 0, 0, 0.05);
}
.transfer-ownership-dialog .dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 24px;
}
.transfer-ownership-dialog .dialog-content .search-section {
  margin-bottom: 24px;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-icon {
  position: absolute;
  left: 12px;
  color: #666;
  z-index: 1;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-input::placeholder {
  color: #999;
}
.transfer-ownership-dialog .dialog-content .users-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.transfer-ownership-dialog .dialog-content .users-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.transfer-ownership-dialog .dialog-content .users-section .section-header .pagination-info {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 12px;
}
.transfer-ownership-dialog .dialog-content .users-section .searching-users {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
}
.transfer-ownership-dialog .dialog-content .users-section .searching-users span {
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .users-section .no-users {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #999;
}
.transfer-ownership-dialog .dialog-content .users-section .no-users mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.5;
}
.transfer-ownership-dialog .dialog-content .users-section .no-users span {
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list {
  margin-bottom: 16px;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option {
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option:hover {
  background-color: #f8f9fa;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-placeholder mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: white;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info {
  flex: 1;
  min-width: 0;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info .user-email {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn:disabled {
  opacity: 0.5;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
  overflow: visible;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers {
  display: flex;
  gap: 4px;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn {
  min-width: 32px;
  height: 32px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  background: white;
  color: #666;
  transition: all 0.2s ease;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn.active {
  background: #5ea1d8;
  color: white;
  border-color: #5ea1d8;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.transfer-ownership-dialog .dialog-content .selected-user-section {
  margin-bottom: 24px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header .change-user-btn {
  color: #5ea1d8;
  font-size: 12px;
  padding: 4px 8px;
  min-height: 32px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header .change-user-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-placeholder mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: white;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info {
  flex: 1;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  font-size: 16px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-email {
  color: #666;
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning .warning-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning .warning-header .warning-icon {
  color: #f39c12;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning .warning-header h4 {
  margin: 0;
  color: #856404;
  font-size: 14px;
  font-weight: 600;
}
.transfer-ownership-dialog .dialog-content .ownership-warning p {
  margin: 0;
  color: #856404;
  font-size: 13px;
  line-height: 1.4;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .form-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .form-header .char-count {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 8px;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field {
  width: 100%;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field ::ng-deep .mat-form-field-outline {
  border-radius: 8px;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field textarea {
  font-size: 14px;
  line-height: 1.4;
}
.transfer-ownership-dialog .dialog-actions {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  position: sticky;
  bottom: 12px;
  min-height: 60px;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn,
.transfer-ownership-dialog .dialog-actions .transfer-btn,
.transfer-ownership-dialog .dialog-actions .confirm-user-btn {
  flex: 1;
  height: 40px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn mat-icon,
.transfer-ownership-dialog .dialog-actions .transfer-btn mat-icon,
.transfer-ownership-dialog .dialog-actions .confirm-user-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn {
  background: white;
  color: #666;
  border: 1px solid #e0e0e0;
  margin-top: 20px !important;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn:hover {
  background: #f5f5f5;
  border-color: #ccc;
}
.transfer-ownership-dialog .dialog-actions .confirm-user-btn {
  background: #28a745;
  color: white;
  border: none;
}
.transfer-ownership-dialog .dialog-actions .confirm-user-btn:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.transfer-ownership-dialog .dialog-actions .confirm-user-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.transfer-ownership-dialog .dialog-actions .transfer-btn {
  background: #5ea1d8;
  color: white;
  border: none;
}
.transfer-ownership-dialog .dialog-actions .transfer-btn:hover:not(:disabled) {
  background: #56baed;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}
.transfer-ownership-dialog .dialog-actions .transfer-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.transfer-ownership-dialog .progress-bar {
  height: 4px;
  border-radius: 0;
}

@media (max-width: 768px) {
  .transfer-ownership-dialog {
    max-height: 95vh;
    width: 95vw;
    max-width: none;
    margin: 8px;
    border-radius: 8px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .transfer-ownership-dialog .dialog-header {
    padding: 16px 20px;
  }
  .transfer-ownership-dialog .dialog-header h2 {
    font-size: 18px;
  }
  .transfer-ownership-dialog .dialog-content {
    padding: 20px;
    max-height: calc(95vh - 140px);
    overflow-y: auto;
  }
  .transfer-ownership-dialog .dialog-content .search-section {
    margin-bottom: 20px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .section-header .pagination-info {
    align-self: flex-end;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn {
    width: 28px;
    height: 28px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    overflow: visible;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn {
    min-width: 28px;
    height: 28px;
    font-size: 11px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header .change-user-btn {
    align-self: flex-end;
  }
  .transfer-ownership-dialog .dialog-actions {
    padding: 16px 20px;
    min-height: 56px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn,
  .transfer-ownership-dialog .dialog-actions .transfer-btn {
    height: 44px;
    font-size: 13px;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn mat-icon,
  .transfer-ownership-dialog .dialog-actions .transfer-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 480px) {
  .transfer-ownership-dialog {
    max-height: 98vh;
    width: 98vw;
    margin: 4px;
    border-radius: 6px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .transfer-ownership-dialog .dialog-header {
    padding: 12px 16px;
  }
  .transfer-ownership-dialog .dialog-header h2 {
    font-size: 16px;
  }
  .transfer-ownership-dialog .dialog-content {
    padding: 16px;
    max-height: calc(98vh - 120px);
    overflow-y: auto;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn {
    width: 24px;
    height: 24px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
    overflow: visible;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn {
    min-width: 24px;
    height: 24px;
    font-size: 10px;
  }
  .transfer-ownership-dialog .dialog-actions {
    padding: 12px 16px;
    min-height: 52px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn,
  .transfer-ownership-dialog .dialog-actions .transfer-btn {
    height: 42px;
    font-size: 12px;
    gap: 6px;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn mat-icon,
  .transfer-ownership-dialog .dialog-actions .transfer-btn mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}
/* Mobile-specific dialog improvements */
@media (max-width: 768px) {
  .mat-mdc-dialog-container {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  .mat-mdc-dialog-surface {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  .cdk-overlay-pane {
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
}
.restricted-access-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0 8px;
  border-top: 1px solid #e0e0e0;
  margin-top: 12px;
}

.btn.btn-primary,
.btn-primary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #5ea1d8;
  color: #ffffff;
  text-transform: none;
  letter-spacing: 0;
}
.btn.btn-primary:hover:not(:disabled),
.btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.btn.btn-primary:disabled,
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/restricted-access/restricted-access.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;iEAAA;AAKE;EAAa,8BAAA;AAEf;AAAE;EACE,8BAAA;EACA,oCAAA;AAEJ;AACE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;AACJ;AAEE;;EAEE,8BAAA;AAAJ;AAGE;EACE,wDAAA;AADJ;AAIE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAFJ;AAMI;EAAqB,yBAAA;AAHzB;AAKI;EACE,8BAAA;EACA,yBAAA;AAHN;AAMI;EACE,8BAAA;EACA,iDAAA;AAJN;AAKM;EAAK,yBAAA;AAFX;AAKI;EACE,oCAAA;EACA,8BAAA;AAHN;AAKI;EAAgC,yBAAA;AAFpC;AAGI;EAAiC,yBAAA;AAArC;AACI;EAA8B,yBAAA;AAElC;AADI;EAAa,yBAAA;AAIjB;AAHI;;;EAEY,yBAAA;AAMhB;AAHE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAKJ;AAHI;EAAyB,8BAAA;AAM7B;AALI;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AAON;AAHE;EACE,qDAAA;AAKJ;;AADA,mDAAA;AACA;EACE,mBAAA;AAIF;AAHE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAKJ;AAJI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAMN;AAJI;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AAMN;AALM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAOR;AALM;EACE,WAAA;AAOR;;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAGJ;AAFI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAIN;AAFI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAIN;AAAE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;AAAI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAEN;AACI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AACN;AAEI;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAAN;AAEM;EACE,gBAAA;AAAR;AAGM;EACE,YAAA;EACA,YAAA;AADR;AAGQ;EACE,UAAA;AADV;AAOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AALJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAMI;EACE,kBAAA;EACA,kBAAA;EACA,sCAAA;AAJN;AAMI;EACE,yBAAA;AAJN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAJN;AAMI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAJN;AAMI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJN;AAMI;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAMI;EACE,OAAA;EACA,YAAA;AAJN;AAMI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAJN;AAMI;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJN;AAOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AALJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAOE;EACE,mBAAA;AALJ;AAOE;EACE,uBAAA;AALJ;AAOE;EACE,aAAA;EACA,QAAA;AALJ;AAOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAOE;EACE,mBAAA;EACA,kBAAA;AALJ;AAOE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AALJ;;AAQA,4BAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AALF;AAOE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AALJ;;AASA,kBAAA;AACA;EACE,kBAAA;EACA,mBAAA;AANF;AAQE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AANJ;AASE;EACE,WAAA;EACA,eAAA;EACA,SAAA;AAPJ;;AAWA,mBAAA;AACA;EACE,mBAAA;AARF;AAUE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AARJ;AAUI;EACE,qBAAA;AARN;AAWI;EACE,WAAA;AATN;;AAcA,kBAAA;AACA;EACE,mBAAA;AAXF;AAaE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,iCAAA;AAXJ;AAaI;EACE,yBAAA;AAXN;AAcI;EACE,kBAAA;AAZN;AAeI;EACE,kBAAA;EACA,eAAA;AAbN;AAeM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAbR;AAgBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdR;AAgBQ;EACE,eAAA;EACA,WAAA;AAdV;AAmBI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjBN;AAmBM;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAjBR;AAoBM;EACE,WAAA;EACA,eAAA;AAlBR;AAqBM;EACE,WAAA;EACA,eAAA;AAnBR;;AAyBA,oBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAtBF;AAwBE;EACE,iBAAA;AAtBJ;;AA0BA,mBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;AAvBF;AAyBE;EACE,WAAA;AAvBJ;AA0BE;EACE,yBAAA;EACA,YAAA;AAxBJ;AA0BI;EACE,sBAAA;EACA,WAAA;AAxBN;;AA6BA,UAAA;AAEA;EACE,uBAAA;AA3BF;;AA6BA;EACE,iBAAA;AA1BF;;AA4BA;EACE,yBAAA;AAzBF;;AA4BA;EACE,kCAAA;EACA,aAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAzBF;;AA4BA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AA1BF;;AA6BA;EAEE,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EACA,kBAAA;EACA,6BAAA;AA1BF;;AA6BA;EACE,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AA1BF;;AA6BA,SAAA;AAEA;EACE,cAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,gCAAA;AA3BF;;AA8BA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AA5BF;;AA+BA;;;EAGE,yBAAA;AA5BF;;AA+BA;;;EAOE,sBAAA;AA5BF;;AA+BA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AA5BF;;AA+BA;;EAEE,sBAAA;EACA,gCAAA;AA5BF;;AA+BA;;EAEE,cAAA;AA5BF;;AA+BA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AA7BF;AA6CA;EACE;IACE,UAAA;IAEA,mCAAA;EA9BF;EAgCA;IACE,UAAA;IAEA,eAAA;EA9BF;AACF;AAiCA,kCAAA;AAiBA;EACE;IACE,UAAA;EA/BF;EAiCA;IACE,UAAA;EA/BF;AACF;AAkCA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AAlCF;;AAqCA;EAGE,qBAAA;AAlCF;;AAqCA;EAGE,qBAAA;EACA,6BAAA;AAlCF;;AAqCA;EAGE,qBAAA;EACA,6BAAA;AAlCF;;AAqCA;EAGE,mBAAA;EACA,6BAAA;AAlCF;;AAqCA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAlCF;;AAqCA;EACE,cAAA;AAlCF;;AAqCA;EACE,WAAA;AAlCF;;AAqCA,WAAA;AAEA;EACE,aAAA;AAnCF;;AAsCA;EACE,UAAA;AAnCF;;AAqCA;EACE,mBAAA;AAlCF;;AAqCA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AAlCF;;AAqCA;EACE,WAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAlCF;;AAqCA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AAlCF;;AAoCA;EACE,gBAAA;EACA,sBAAA;EAGA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,wCAAA;UAAA,gCAAA;AAnCF;;AAqCA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAlCF;;AAoCA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AAjCF;;AAmCA;EACE,gBAAA;EACA,uBAAA;AAhCF;AAiCE;EACE,sBAAA;AA/BJ;;AAmCA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAhCF;AAuCM;EACE,8BAAA;EACA,2BAAA;AArCR;AAyCE;EACE,yBAAA;AAvCJ;;AA0CA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAxCF;;AA0CA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAxCF;;AA2CA;EACE,yBAAA;EACA,WAAA;AAxCF;;AA0CA;EACE,qBAAA;EACA,uBAAA;AAvCF;;AAyCA;EACE,6BAAA;AAtCF;;AAwCA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AArCF;;AAuCA;EACE,WAAA;EACA,YAAA;AApCF;;AAsCA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAnCF;;AAqCA;EACE,iBAAA;AAlCF;;AAqCA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AAlCF;;AAoCA;EACE,gBAAA;EACA,kBAAA;AAjCF;;AAoCA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAjCF;;AAmCA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAhCF;;AAkCA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;AA/BF;;AAiCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAhCF;;AAmCA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAhCF;;AAmCA;EACE,yBAAA;AAhCF;;AAmCA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAhCF;;AAoCA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AAjCF;;AAmCA;EACE,aAAA;EACA,mBAAA;AAhCF;AAiCE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AA/BJ;;AAkCA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AA/BF;;AAiCA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AA9BF;AA+BE;EACE,aAAA;AA7BJ;;AAgCA;EACE;IACE,eAAA;EA7BF;AACF;AAgCA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AA9BF;;AAgCA;EACE,gBAAA;EACA,sBAAA;EAEA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA9BF;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,gCAAA;AA7BF;AA8BE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AA5BJ;AA8BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AA5BJ;;AA+BA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA5BF;;AA8BA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;AA3BF;;AA6BA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AA1BF;;AA4BA;EACE,gBAAA;EACA,uBAAA;AAzBF;AA0BE;EACE,sBAAA;AAxBJ;;AA4BA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAzBF;AAgCM;EACE,8BAAA;EACA,2BAAA;EACA,2BAAA;AA9BR;AAkCE;EACE,yBAAA;AAhCJ;;AAmCA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAhCF;;AAmCA;EACE,yBAAA;EACA,aAAA;AAhCF;;AAkCA;EACE,6BAAA;AA/BF;;AAiCA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA9BF;;AAgCA;EACE,WAAA;EACA,YAAA;AA7BF;;AA+BA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AA5BF;;AA8BA;EACE,iBAAA;AA3BF;;AA8BA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AA3BF;;AA6BA;EACE,gBAAA;EACA,kBAAA;AA1BF;;AA6BA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA1BF;;AA4BA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAzBF;;AA2BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAxBF;;AA0BA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAzBF;;AA4BA;EACE,yBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAzBF;;AA6BA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AA1BF;;AA4BA;EACE,aAAA;EACA,mBAAA;AAzBF;AA0BE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AAxBJ;;AA2BA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAxBF;;AA0BA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AAvBF;AAwBE;EACE,aAAA;AAtBJ;;AAyBA;EACE;IACE,eAAA;IACA,2BAAA;EAtBF;EAuBE;IACE,WAAA;IACA,aAAA;EArBJ;EAwBA;IACE,eAAA;IACA,sBAAA;IACA,6BAAA;IACA,4BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;EAtBF;EAwBA;IACE,QAAA;IACA,UAAA;EAtBF;AACF;AAwBA;EACE,YAAA;EACA,gBAAA;AAtBF;AAuBE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AArBJ;AAwBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAtBJ;AAuBI;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AArBN;AAuBM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AArBR;AA0BE;EACE,gBAAA;AAxBJ;AA0BI;EACE,iBAAA;AAxBN;;AA6BA,yBAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AA1BF;AA4BE;EACE,SAAA;AA1BJ;AA4BI;EACE,WAAA;AA1BN;AA6BI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA3BN;AA8BI;EACE,WAAA;AA5BN;AA8BM;EACE,WAAA;AA5BR;AA+BM;EACE,sBAAA;EACA,kBAAA;AA7BR;AAgCM;EACE,6BAAA;AA9BR;AAiCM;EACE,eAAA;EACA,cAAA;AA/BR;AAiCQ;EACE,cAAA;EACA,YAAA;AA/BV;AAmCM;EACE,cAAA;EACA,eAAA;AAjCR;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AApCF;AAuCE;EACE,mBAAA;EACA,cAAA;AArCJ;AAyCE;EAlBF;IAmBI,yBAAA;EAtCF;AACF;AAyCE;EACE;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;EAvCJ;AACF;AA0CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,gCAAA;AAxCJ;AA0CI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAxCN;AA2CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAzCN;AA4CI;EACE,WAAA;EACA,2BAAA;AA1CN;AA4CM;EACE,WAAA;EACA,+BAAA;AA1CR;AA+CE;EACE,cAAA;EACA,gBAAA;EACA,aAAA;AA7CJ;AA+CI;EACE,mBAAA;AA7CN;AA+CM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA7CR;AA+CQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AA7CV;AAgDQ;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AA9CV;AAgDU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA9CZ;AAiDU;EACE,WAAA;AA/CZ;AAsDM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AApDR;AAsDQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApDV;AAuDQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AArDV;AAyDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAvDR;AAyDQ;EACE,eAAA;AAvDV;AA2DM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAzDR;AA2DQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAzDV;AA4DQ;EACE,eAAA;AA1DV;AA8DM;EACE,mBAAA;AA5DR;AA8DQ;EACE,kBAAA;EACA,kBAAA;EACA,sCAAA;AA5DV;AA8DU;EACE,yBAAA;AA5DZ;AA+DU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA7DZ;AA+DY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA7Dd;AA+Dc;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA7DhB;AAgEc;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA9DhB;AAgEgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA9DlB;AAmEY;EACE,OAAA;EACA,YAAA;AAjEd;AAmEc;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAjEhB;AAoEc;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlEhB;AAyEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAvER;AAyEQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvEV;AAyEU;EACE,YAAA;AAvEZ;AA0EU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAxEZ;AA4EQ;EACE,aAAA;EACA,QAAA;AA1EV;AA4EU;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AA1EZ;AA4EY;EACE,mBAAA;EACA,kBAAA;AA1Ed;AA6EY;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AA3Ed;AA8EY;EACE,YAAA;EACA,mBAAA;AA5Ed;AAmFI;EACE,mBAAA;AAjFN;AAmFM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjFR;AAmFQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAjFV;AAoFQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAlFV;AAoFU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlFZ;AAuFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AArFR;AAuFQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AArFV;AAuFU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArFZ;AAwFU;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAtFZ;AAwFY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAtFd;AA2FQ;EACE,OAAA;AAzFV;AA2FU;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAzFZ;AA4FU;EACE,WAAA;EACA,eAAA;AA1FZ;AAgGI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA9FN;AAgGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA9FR;AAgGQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA9FV;AAiGQ;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/FV;AAmGM;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjGR;AAsGM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AApGR;AAsGQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApGV;AAuGQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AArGV;AAyGM;EACE,WAAA;AAvGR;AAyGQ;EACE,iBAAA;AAvGV;AA0GQ;EACE,kBAAA;AAxGV;AA2GQ;EACE,eAAA;EACA,gBAAA;AAzGV;AA+GE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AA7GJ;AA+GI;;;EAGE,OAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA7GN;AA+GM;;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3GR;AA+GI;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;AA7GN;AA8GM;EACE,mBAAA;EACA,kBAAA;AA5GR;AAgHI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AA9GN;AAgHM;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AA9GR;AAiHM;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/GR;AAmHI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AAjHN;AAmHM;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;AAjHR;AAoHM;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAlHR;AAuHE;EACE,WAAA;EACA,gBAAA;AArHJ;;AA0HA;EACE;IACE,gBAAA;IACA,WAAA;IACA,eAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;EAvHF;EAyHE;IACE,kBAAA;EAvHJ;EAyHI;IACE,eAAA;EAvHN;EA2HE;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;EAzHJ;EA2HI;IACE,mBAAA;EAzHN;EA6HM;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EA3HR;EA6HQ;IACE,oBAAA;EA3HV;EAgIQ;IACE,WAAA;IACA,YAAA;EA9HV;EAgIU;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA9HZ;EAmIU;IACE,eAAA;IACA,YAAA;IACA,eAAA;EAjIZ;EAwIM;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAtIR;EAwIQ;IACE,oBAAA;EAtIV;EA4IE;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;EA1IJ;EA4II;;IAEE,YAAA;IACA,eAAA;EA1IN;EA4IM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzIR;AACF;AA+IA;EACE;IACE,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;EA7IF;EA+IE;IACE,kBAAA;EA7IJ;EA+II;IACE,eAAA;EA7IN;EAiJE;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;EA/IJ;EAmJQ;IACE,WAAA;IACA,YAAA;EAjJV;EAmJU;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EAjJZ;EAsJU;IACE,eAAA;IACA,YAAA;IACA,eAAA;EApJZ;EA2JE;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;EAzJJ;EA2JI;;IAEE,YAAA;IACA,eAAA;IACA,QAAA;EAzJN;EA2JM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAxJR;AACF;AA8JA,wCAAA;AACA;EACE;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EA5JF;EA+JA;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EA7JF;EAgKA;IACE,2BAAA;IACA,4BAAA;EA9JF;AACF;AAiKA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AA/JF;;AAkKA;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AA/JF;AAiKE;;EACE,mBAAA;AA9JJ;AAiKE;;EACE,YAAA;EACA,mBAAA;AA9JJ","sourcesContent":["/* ── Dark mode overrides ─────────────────────────────────────\n   Use body.theme-dark (not :host-context) so rules apply to\n   Material Dialog content rendered in the CDK overlay.\n   ──────────────────────────────────────────────────────────── */\nbody.theme-dark .cdk-overlay-pane.dialoguebox app-restricted-access {\n  .container { background: #111827 !important; }\n\n  .box {\n    background: #111827 !important;\n    background-color: #111827 !important;\n  }\n\n  .des-box {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .des-box::after,\n  .des-box::before {\n    background: #111827 !important;\n  }\n\n  .dialog-header {\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .search-input {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .users-section {\n    .section-header h3 { color: #e2e8f0 !important; }\n\n    .pagination-info {\n      background: #1f2937 !important;\n      color: #94a3b8 !important;\n    }\n\n    .selected-users {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n      h4 { color: #e2e8f0 !important; }\n    }\n\n    .user-option:hover {\n      background-color: #253347 !important;\n      background: #253347 !important;\n    }\n    .user-option:hover .user-name { color: #e2e8f0 !important; }\n    .user-option:hover .user-email { color: #94a3b8 !important; }\n    .user-option:hover mat-icon { color: #e2e8f0 !important; }\n    .user-name { color: #e2e8f0 !important; }\n    .user-email,\n    .searching-users,\n    .no-users { color: #94a3b8 !important; }\n  }\n\n  .page-btn {\n    background: #1f2937 !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n\n    &:hover:not(:disabled) { background: #2d3748 !important; }\n    &.active {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n      border-color: #5ea1d8 !important;\n    }\n  }\n\n  .action-buttons {\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n}\n\n/* Match Transfer Ownership styles for users list */\n.search-section {\n  margin-bottom: 24px;\n  .search-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    .search-icon {\n      position: absolute;\n      left: 12px;\n      color: #666;\n      z-index: 1;\n    }\n    .search-input {\n      width: 100%;\n      padding: 12px 12px 12px 44px;\n      border: 2px solid #e0e0e0;\n      border-radius: 8px;\n      font-size: 14px;\n      transition: border-color 0.2s ease;\n      &:focus {\n        outline: none;\n        border-color: #5ea1d8;\n        box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n      }\n      &::placeholder {\n        color: #999;\n      }\n    }\n  }\n}\n\n.users-section {\n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n    }\n    .pagination-info {\n      font-size: 12px;\n      color: #666;\n      background: #f5f5f5;\n      padding: 4px 8px;\n      border-radius: 12px;\n    }\n  }\n\n  .selected-users {\n    margin-bottom: 20px;\n    padding: 16px;\n    background: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n\n    h4 {\n      margin: 0 0 12px 0;\n      font-size: 14px;\n      font-weight: 600;\n      color: #333;\n    }\n\n    mat-chip-listbox {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n    }\n\n    mat-chip-option {\n      background: #d8e4f7;\n      color: white;\n      font-size: 12px;\n\n      &:hover {\n        background: #999;\n      }\n\n      .mat-mdc-chip-remove {\n        color: white;\n        opacity: 0.8;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  .searching-users {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px;\n    color: #666;\n  }\n  .no-users {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px;\n    color: #999;\n  }\n  .users-list {\n    margin-bottom: 16px;\n    .user-option {\n      border-radius: 8px;\n      margin-bottom: 8px;\n      transition: background-color 0.2s ease;\n    }\n    .user-option:hover {\n      background-color: #eef2f7;\n    }\n    .user-item {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 8px 12px;\n      min-width: 0;\n    }\n    .user-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n    }\n    .avatar-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n    .avatar-placeholder {\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n      color: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 16px;\n      font-weight: 600;\n    }\n    .user-info {\n      flex: 1;\n      min-width: 0;\n    }\n    .user-name {\n      font-weight: 600;\n      color: #333;\n      margin-bottom: 2px;\n      font-size: 14px;\n    }\n    .user-email {\n      color: #666;\n      font-size: 12px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  .pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 16px;\n  }\n  .nav-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .nav-btn:hover {\n    background: #f5f5f5;\n  }\n  .nav-btn:disabled:hover {\n    background: transparent;\n  }\n  .page-numbers {\n    display: flex;\n    gap: 4px;\n  }\n  .page-btn {\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid #e0e0e0;\n    background: #fff;\n    color: #666;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .page-btn:hover:not(:disabled) {\n    background: #f5f5f5;\n    border-color: #ccc;\n  }\n  .page-btn.active {\n    background: #5ea1d8;\n    color: #fff;\n    border-color: #5ea1d8;\n  }\n}\n/* Create Flow Mode Notice */\n.create-flow-notice {\n  background: #e3f2fd;\n  border: 1px solid #5ea1d8;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #1976d2;\n\n  .notice-icon {\n    color: #5ea1d8;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* Title Section */\n.title-section {\n  text-align: center;\n  margin-bottom: 20px;\n\n  h2 {\n    color: #333;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  p {\n    color: #666;\n    font-size: 14px;\n    margin: 0;\n  }\n}\n\n/* Search Section */\n.search-section {\n  margin-bottom: 20px;\n\n  .search-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.3s;\n\n    &:focus {\n      border-color: #5ea1d8;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n}\n\n/* Users Section */\n.users-section {\n  margin-bottom: 20px;\n\n  .user-item {\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.2s;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    .transfer-checkbox {\n      margin-right: 16px;\n    }\n\n    .user-avatar {\n      margin-right: 16px;\n      cursor: pointer;\n\n      .avatar-image {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n\n      .avatar-placeholder {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        background-color: #e0e0e0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .material-icons {\n          font-size: 24px;\n          color: #666;\n        }\n      }\n    }\n\n    .user-info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .user-name {\n        font-weight: 600;\n        color: #333;\n        font-size: 16px;\n      }\n\n      .user-username {\n        color: #666;\n        font-size: 14px;\n      }\n\n      .user-email {\n        color: #999;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n/* Loading Section */\n.loading-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  color: #666;\n\n  mat-spinner {\n    margin-right: 8px;\n  }\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n\n  .cancel-btn {\n    color: #666;\n  }\n\n  .confirm-btn {\n    background-color: #5ea1d8;\n    color: white;\n\n    &:disabled {\n      background-color: #ccc;\n      color: #666;\n    }\n  }\n}\n\n/* BASIC */\n\n.Login {\n  background-color: white;\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 30px;\n  width: 90%;\n  max-width: 450px;\n  position: relative;\n  padding: 0px;\n  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: 0.5px solid lightgrey;\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  border-top: 1px solid #dce8f1;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n.box {\n  max-width: 560px;\n  width: 100% !important;\n  // max-height:90vh;\n  // min-height:77vh !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff !important;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n  background-size: cover;\n  background-position: center;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n  opacity: 1 !important;\n  backdrop-filter: none !important;\n}\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 100vh;\n  // height:-webkit-fill-available;\n  background: #fff;\n  border-radius: 0px;\n  position: absolute;\n  top: 0px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n.des-box:before {\n  content: \"\";\n  width: 200%;\n  height: 40vh;\n  // height:-webkit-fill-available;\n  background: #fff;\n  border-radius: 100% 100% 0px 0px;\n  position: absolute;\n  top: -34px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n}\n.priceIcon-p {\n  top: unset !important;\n  bottom: 20px !important;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n  top: 15px;\n  right: 25px;\n  color: white;\n  opacity: 1 !important;\n  z-index: 10;\n}\n.close-ico .close-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  border: 1px solid #5ea1d8;\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 10px;\n  mat-card {\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n  }\n}\n\n.container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n.box {\n  max-width: 500px;\n  width: 100% !important;\n  // max-height:90vh;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: #fff;\n  border-radius: 0px;\n  margin: 0px auto;\n}\n.dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 0 8px 0;\n  background: transparent;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  h2 {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #333;\n  }\n  .header-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n    color: #333;\n  }\n}\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.popuptitle {\n  text-align: left;\n  font-size: 20px !important;\n  padding-left: 15px;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 100vh;\n  background: #fff;\n  border-radius: 0px !important;\n  position: absolute;\n  top: -100px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 80px 0px;\n  display: none;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #212427;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n}\n.close-ico .close-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  border: 1px solid #5ea1d8;\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 10px;\n  mat-card {\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    span {\n      width: 100%;\n      display: flex;\n    }\n  }\n  .box {\n    max-width: 47vh;\n    width: 95vw !important;\n    margin: 2.5vh auto !important;\n    padding: 0px 15px !important;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n  }\n  .close-ico {\n    top: 8px;\n    right: 8px;\n  }\n}\n.ownership-warning {\n  margin: 20px;\n  text-align: left;\n  .note-box {\n    background-color: #fff3cd;\n    color: #856404;\n    border: 1px solid #ffeeba;\n    border-radius: 5px;\n    padding: 15px;\n    font-size: 14px;\n  }\n\n  .note-list {\n    margin: 10px 0;\n    padding-left: 0;\n    list-style: none;\n    li {\n      position: relative;\n      padding-left: 20px;\n      margin-bottom: 8px;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 6px;\n        width: 8px;\n        height: 8px;\n        background-color: #856404;\n        border-radius: 50%;\n      }\n    }\n  }\n\n  .ownership-buttons {\n    margin-top: 15px;\n\n    button + button {\n      margin-left: 10px;\n    }\n  }\n}\n\n/* Comment Form Styling */\n.comment-form-section {\n  margin: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n\n  .example-form {\n    margin: 0;\n\n    .w-100 {\n      width: 100%;\n    }\n\n    .font16 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #495057;\n    }\n\n    mat-form-field {\n      width: 100%;\n\n      .mat-mdc-form-field {\n        width: 100%;\n      }\n\n      .mat-mdc-text-field-wrapper {\n        background-color: #fff;\n        border-radius: 6px;\n      }\n\n      .mat-mdc-form-field-focus-overlay {\n        background-color: transparent;\n      }\n\n      input {\n        font-size: 14px;\n        color: #495057;\n\n        &::placeholder {\n          color: #6c757d;\n          opacity: 0.7;\n        }\n      }\n\n      .mat-mdc-form-field-hint {\n        color: #6c757d;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n.transfer-ownership-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  width: 100%;\n  max-width: 600px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    background: #1a1a1a;\n    color: #ffffff;\n  }\n\n  // High contrast support\n  @media (prefers-contrast: high) {\n    border: 2px solid #000000;\n  }\n\n  // Reduced motion support\n  @media (prefers-reduced-motion: reduce) {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    background: transparent;\n    color: #333;\n    border-bottom: 1px solid #e0e0e0;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #333;\n    }\n\n    .header-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      color: #333;\n    }\n\n    .close-button {\n      color: #666;\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: #333;\n        background: rgba(0, 0, 0, 0.05);\n      }\n    }\n  }\n\n  .dialog-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: 24px;\n\n    .search-section {\n      margin-bottom: 24px;\n\n      .search-input-wrapper {\n        position: relative;\n        display: flex;\n        align-items: center;\n\n        .search-icon {\n          position: absolute;\n          left: 12px;\n          color: #666;\n          z-index: 1;\n        }\n\n        .search-input {\n          width: 100%;\n          padding: 12px 12px 12px 44px;\n          border: 2px solid #e0e0e0;\n          border-radius: 8px;\n          font-size: 14px;\n          transition: border-color 0.2s ease;\n\n          &:focus {\n            outline: none;\n            border-color: #5ea1d8;\n            box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n          }\n\n          &::placeholder {\n            color: #999;\n          }\n        }\n      }\n    }\n\n    .users-section {\n      .section-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 16px;\n\n        h3 {\n          margin: 0;\n          font-size: 16px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .pagination-info {\n          font-size: 12px;\n          color: #666;\n          background: #f5f5f5;\n          padding: 4px 8px;\n          border-radius: 12px;\n        }\n      }\n\n      .searching-users {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        padding: 32px;\n        color: #666;\n\n        span {\n          font-size: 14px;\n        }\n      }\n\n      .no-users {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        padding: 32px;\n        color: #999;\n\n        mat-icon {\n          font-size: 48px;\n          width: 48px;\n          height: 48px;\n          opacity: 0.5;\n        }\n\n        span {\n          font-size: 14px;\n        }\n      }\n\n      .users-list {\n        margin-bottom: 16px;\n\n        .user-option {\n          border-radius: 8px;\n          margin-bottom: 8px;\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background-color: #f8f9fa;\n          }\n\n          .user-item {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 8px 0;\n\n            .user-avatar {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              overflow: hidden;\n              flex-shrink: 0;\n\n              .avatar-image {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n              }\n\n              .avatar-placeholder {\n                width: 100%;\n                height: 100%;\n                background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n                color: white;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 16px;\n                font-weight: 600;\n\n                mat-icon {\n                  font-size: 20px;\n                  width: 20px;\n                  height: 20px;\n                  color: white;\n                }\n              }\n            }\n\n            .user-info {\n              flex: 1;\n              min-width: 0;\n\n              .user-name {\n                font-weight: 600;\n                color: #333;\n                margin-bottom: 2px;\n                font-size: 14px;\n              }\n\n              .user-email {\n                color: #666;\n                font-size: 12px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n            }\n          }\n        }\n      }\n\n      .pagination-controls {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        margin-top: 16px;\n\n        .nav-btn {\n          width: 32px;\n          height: 32px;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &:disabled {\n            opacity: 0.5;\n          }\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n            line-height: 1;\n            overflow: visible;\n          }\n        }\n\n        .page-numbers {\n          display: flex;\n          gap: 4px;\n\n          .page-btn {\n            min-width: 32px;\n            height: 32px;\n            border-radius: 6px;\n            font-size: 12px;\n            font-weight: 500;\n            border: 1px solid #e0e0e0;\n            background: white;\n            color: #666;\n            transition: all 0.2s ease;\n\n            &:hover:not(:disabled) {\n              background: #f5f5f5;\n              border-color: #ccc;\n            }\n\n            &.active {\n              background: #5ea1d8;\n              color: white;\n              border-color: #5ea1d8;\n            }\n\n            &:disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n            }\n          }\n        }\n      }\n    }\n\n    .selected-user-section {\n      margin-bottom: 24px;\n\n      .selected-user-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 16px;\n\n        h3 {\n          margin: 0;\n          font-size: 16px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .change-user-btn {\n          color: #5ea1d8;\n          font-size: 12px;\n          padding: 4px 8px;\n          min-height: 32px;\n\n          mat-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n\n      .selected-user-card {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n        padding: 16px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        border: 2px solid #e9ecef;\n\n        .user-avatar {\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          overflow: hidden;\n          flex-shrink: 0;\n\n          .avatar-image {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n\n          .avatar-placeholder {\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n            color: white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 20px;\n            font-weight: 600;\n\n            mat-icon {\n              font-size: 24px;\n              width: 24px;\n              height: 24px;\n              color: white;\n            }\n          }\n        }\n\n        .user-info {\n          flex: 1;\n\n          .user-name {\n            font-weight: 600;\n            color: #333;\n            margin-bottom: 4px;\n            font-size: 16px;\n          }\n\n          .user-email {\n            color: #666;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    .ownership-warning {\n      background: #fff3cd;\n      border: 1px solid #ffeaa7;\n      border-radius: 8px;\n      padding: 16px;\n      margin-bottom: 24px;\n\n      .warning-header {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-bottom: 8px;\n\n        .warning-icon {\n          color: #f39c12;\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n\n        h4 {\n          margin: 0;\n          color: #856404;\n          font-size: 14px;\n          font-weight: 600;\n        }\n      }\n\n      p {\n        margin: 0;\n        color: #856404;\n        font-size: 13px;\n        line-height: 1.4;\n      }\n    }\n\n    .comment-form-section {\n      .form-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 12px;\n\n        h4 {\n          margin: 0;\n          font-size: 14px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .char-count {\n          font-size: 12px;\n          color: #666;\n          background: #f5f5f5;\n          padding: 2px 6px;\n          border-radius: 8px;\n        }\n      }\n\n      .comment-field {\n        width: 100%;\n\n        ::ng-deep .mat-form-field-wrapper {\n          padding-bottom: 0;\n        }\n\n        ::ng-deep .mat-form-field-outline {\n          border-radius: 8px;\n        }\n\n        textarea {\n          font-size: 14px;\n          line-height: 1.4;\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    gap: 12px;\n    padding: 20px 24px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    position: sticky;\n    bottom: 12px;\n    min-height: 60px;\n\n    .cancel-btn,\n    .transfer-btn,\n    .confirm-user-btn {\n      flex: 1;\n      height: 40px;\n      border-radius: 8px;\n      font-weight: 500;\n      font-size: 14px;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    .cancel-btn {\n      background: white;\n      color: #666;\n      border: 1px solid #e0e0e0;\n      margin-top: 20px !important;\n      &:hover {\n        background: #f5f5f5;\n        border-color: #ccc;\n      }\n    }\n\n    .confirm-user-btn {\n      background: #28a745;\n      color: white;\n      border: none;\n\n      &:hover:not(:disabled) {\n        background: #218838;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n      }\n\n      &:disabled {\n        background: #ccc;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n\n    .transfer-btn {\n      background: #5ea1d8;\n      color: white;\n      border: none;\n\n      &:hover:not(:disabled) {\n        background: #56baed;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n      }\n\n      &:disabled {\n        background: #ccc;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .progress-bar {\n    height: 4px;\n    border-radius: 0;\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .transfer-ownership-dialog {\n    max-height: 95vh;\n    width: 95vw;\n    max-width: none;\n    margin: 8px;\n    border-radius: 8px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    .dialog-header {\n      padding: 16px 20px;\n\n      h2 {\n        font-size: 18px;\n      }\n    }\n\n    .dialog-content {\n      padding: 20px;\n      max-height: calc(95vh - 140px);\n      overflow-y: auto;\n\n      .search-section {\n        margin-bottom: 20px;\n      }\n\n      .users-section {\n        .section-header {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 8px;\n\n          .pagination-info {\n            align-self: flex-end;\n          }\n        }\n\n        .pagination-controls {\n          .nav-btn {\n            width: 28px;\n            height: 28px;\n\n            mat-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n              overflow: visible;\n            }\n          }\n\n          .page-numbers {\n            .page-btn {\n              min-width: 28px;\n              height: 28px;\n              font-size: 11px;\n            }\n          }\n        }\n      }\n\n      .selected-user-section {\n        .selected-user-header {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 8px;\n\n          .change-user-btn {\n            align-self: flex-end;\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 16px 20px;\n      min-height: 56px;\n      position: sticky;\n      bottom: 0;\n      background: #f8f9fa;\n\n      .cancel-btn,\n      .transfer-btn {\n        height: 44px;\n        font-size: 13px;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .transfer-ownership-dialog {\n    max-height: 98vh;\n    width: 98vw;\n    margin: 4px;\n    border-radius: 6px;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    .dialog-header {\n      padding: 12px 16px;\n\n      h2 {\n        font-size: 16px;\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n      max-height: calc(98vh - 120px);\n      overflow-y: auto;\n\n      .users-section {\n        .pagination-controls {\n          .nav-btn {\n            width: 24px;\n            height: 24px;\n\n            mat-icon {\n              font-size: 14px;\n              width: 14px;\n              height: 14px;\n              overflow: visible;\n            }\n          }\n\n          .page-numbers {\n            .page-btn {\n              min-width: 24px;\n              height: 24px;\n              font-size: 10px;\n            }\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 12px 16px;\n      min-height: 52px;\n      position: sticky;\n      bottom: 0;\n      background: #f8f9fa;\n\n      .cancel-btn,\n      .transfer-btn {\n        height: 42px;\n        font-size: 12px;\n        gap: 6px;\n\n        mat-icon {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n  }\n}\n\n/* Mobile-specific dialog improvements */\n@media (max-width: 768px) {\n  .mat-mdc-dialog-container {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  .mat-mdc-dialog-surface {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  .cdk-overlay-pane {\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n}\n\n.restricted-access-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 0 8px;\n  border-top: 1px solid #e0e0e0;\n  margin-top: 12px;\n}\n\n.btn.btn-primary,\n.btn-primary {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: #5ea1d8;\n  color: #ffffff;\n  text-transform: none;\n  letter-spacing: 0;\n\n  &:hover:not(:disabled) {\n    background: #4a8fc4;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
